/// <reference path='../_all.ts' />

module user {
  'use strict';

  export class FormSrvErrorCollection {
    constructor(
      public errors: { [validator: string] : boolean } 
      ) { }
  }
}